/* List of user types */
export const SCHOOL_USER = 'school_user';
export const CANDIDATE = 'candidate';
export const ADMINISTRATOR = 'administrator';

/* List of user type roles */
export const SCHOOL_USER_RECRUITER = 'school_recruiter';
export const SCHOOL_USER_ADMIN = 'school_admin';


/**
 * @var {object} userTypes
 */
export const userTypes = {
  [SCHOOL_USER]: 1,
  [CANDIDATE]: 2,
  [ADMINISTRATOR]: 3
};

/**
 * @var {object} userTypeRoles
 */
export const userTypeRoles = {
  [SCHOOL_USER]: {
    [SCHOOL_USER_RECRUITER]: 1,
    [SCHOOL_USER_ADMIN]: 2,
  }
};

export const userTypeNames = {
  [userTypes.school_user]: 'School User',
  [userTypes.candidate]: 'Candidate',
  [userTypes.administrator]: 'Administrator'
};

export const userTypeRolesNames = {
  [userTypeRoles[SCHOOL_USER][SCHOOL_USER_RECRUITER]]: 'Base Recruiter',
  [userTypeRoles[SCHOOL_USER][SCHOOL_USER_ADMIN]]: 'School Admin'
}


// WEBPACK FOOTER //
// ./src/constants/user.js